import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import en from './locales/en.json';
import zhCN from './locales/zh-CN.json';
import zhTW from './locales/zh-TW.json';
import fr from './locales/fr.json';
import de from './locales/de.json';
import id from './locales/id.json';
import it from './locales/it.json';
import ja from './locales/ja.json';
import ko from './locales/ko.json';
import ptBR from './locales/pt-BR.json';
import esES from './locales/es-ES.json';
import esMX from './locales/es-MX.json';
import ar from './locales/ar.json';

const resources = {
  'zh-CN': { translation: zhCN },
  'zh-TW': { translation: zhTW },
  'en': { translation: en },
  'fr': { translation: fr },
  'de': { translation: de },
  'id': { translation: id },
  'it': { translation: it },
  'ja': { translation: ja },
  'ko': { translation: ko },
  'pt-BR': { translation: ptBR },
  'es-ES': { translation: esES },
  'es-MX': { translation: esMX },
  'ar': { translation: ar },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    defaultNS: 'translation',
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
  });

export default i18n;

